var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.user.activated)?_c('ElButton',{attrs:{"type":"info"},on:{"click":_vm.activateAccount}},[_vm._v(" ACTIVATE ACCOUNT ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }